import axios from "axios";

const validateWinnerImport = async ({ file, luckyDrawUuid, prizeId }) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("lucky_draw_uuid", luckyDrawUuid);
  formData.append("prize_id", prizeId);

  return new Promise((resolve, reject) => {
    axios
      .post(`/campaignV2/customer/luckyDraw/winnerValidate`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
};

export default validateWinnerImport;

/**
 * Validate batch preset winners from multi-sheet Excel file
 * @param {Object} data - FormData containing file and lucky_draw_uuid
 * @returns {Promise} API response
 */
export const validateBatchWinnerImport = (data) => {
  const formData = new FormData();
  formData.append('file', data.file);
  formData.append('lucky_draw_uuid', data.luckyDrawUuid);

  return axios({
    method: 'post',
    url: `/campaignV2/customer/luckyDraw/batchWinnerValidate`,
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
    .then((response) => {
      if (response.data.success) {
        return Promise.resolve(response.data);
      } else {
        return Promise.reject(response.data);
      }
    })
    .catch((error) => {
      if (error.response && error.response.data) {
        return Promise.reject(error.response.data);
      }
      return Promise.reject({
        success: false,
        code: 'error.ERROR_SOMETHING_WRONG',
        message: 'Network error occurred',
      });
    });
};

/**
 * Import batch preset winners from validated multi-sheet Excel file
 * @param {Object} data - {file_path, lucky_draw_uuid, validation_data}
 * @returns {Promise} API response
 */
export const importBatchWinners = (data) => {
  return axios({
    method: 'post',
    url: `/campaignV2/customer/luckyDraw/batchWinnerImport`,
    data: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((response) => {
      if (response.data.success) {
        return Promise.resolve(response.data);
      } else {
        return Promise.reject(response.data);
      }
    })
    .catch((error) => {
      if (error.response && error.response.data) {
        return Promise.reject(error.response.data);
      }
      return Promise.reject({
        success: false,
        code: 'error.ERROR_SOMETHING_WRONG',
        message: 'Network error occurred',
      });
    });
};

/**
 * Download multi-sheet Excel template for batch preset winner import
 * @param {string} luckyDrawUuid - Lucky draw UUID
 * @returns {Promise} Blob response for file download
 */
export const downloadBatchWinnerTemplate = (luckyDrawUuid) => {
  return axios({
    method: 'post',
    url: `/campaignV2/customer/luckyDraw/batchWinnerTemplate`,
    data: JSON.stringify({ lucky_draw_uuid: luckyDrawUuid }),
    headers: {
      'Content-Type': 'application/json',
    },
    responseType: 'blob',
  })
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((error) => {
      if (error.response && error.response.data) {
        return Promise.reject(error.response.data);
      }
      return Promise.reject({
        success: false,
        code: 'error.ERROR_SOMETHING_WRONG',
        message: 'Network error occurred',
      });
    });
}; 